import axios from "axios";

export const state = {
    loantypes: [],
};

export const getters = {
    loantypes: state => state.loantypes,
};

export const mutations = {
    setLoanTypes(state, newValue) {
        state.loantypes = newValue
    },
};

export const actions = {
    async fetchLoanTypes({ commit }) {
        await axios.get('/loantypes').then(res => {
            commit('setLoanTypes', res.data.loantypes)
        })
    },
};
